import { Result, Typography } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { EasebuzzFooter } from '../../utility';

const { Paragraph, Text } = Typography;

const SmartPayError = ({ status = "404", title = "Not found", errorMsg = "The page you are looking for doesn't exist", showDesc = false }) => {
    let footerProps = {
        footerImage: {
            styleClass: 'smart-pay-error-image',
        }
    }
    return (
        <Result
            className="smart-pay-error"
            status={status}
            title={title}
            subTitle={errorMsg}
        >
            {
                showDesc ?
                    <div className="error-desc">
                        <Paragraph>
                            <Text
                                strong
                                style={{
                                    fontSize: 16,
                                }}
                            >
                                The link cannot be opened due to the following purpose:
                            </Text>
                        </Paragraph>
                        <Paragraph>
                            <CloseCircleOutlined className="site-result-demo-error-icon" /> Something might be wrong with the server
                        </Paragraph>
                        <Paragraph>
                            <CloseCircleOutlined className="site-result-demo-error-icon" /> The link might be deactivated.
                        </Paragraph>
                    </div>
                    : null
            }
            <EasebuzzFooter {...footerProps} />
        </Result>

    )
}

export default SmartPayError;